import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";

export default function MonogramStepInitials({ product, config, setConfig }) {
  const numberOfInitials = parseInt(product.monogramSettings.numberOfInitials);

  const initials = config.initials || new Array(numberOfInitials).fill("");

  const handleInitialChange = (e, i) => {
    const newInitials = [...initials];
    newInitials[i] = e.target.value.slice(0, 1).toUpperCase();
    setConfig({ ...config, initials: newInitials });
  };

  return (
    <div className="monogram-config__initials">
      {initials.map((initial, i) => (
        <label className="monogram-config__initial-label">
          <span className="visually-hidden">
            {window.theme.localeStrings.monogram.initial_placeholders[i]}
          </span>
          <input
            className="monogram-config__initial-input"
            type="text"
            value={initial}
            onInput={(e) => handleInitialChange(e, i)}
            maxLength="1"
            placeholder={
              window.theme.localeStrings.monogram.initial_placeholders[i]
            }
          />
        </label>
      ))}
    </div>
  );
}
